import "preact/debug"

import { render } from "htm/preact"
import { route } from "preact-router"
import { trackEvent } from "../utils/analytics"
import { Navbar } from "./components/Navbar"
import { HowToEarnPoints, LeaderboardPopup } from "./components/Leaderboard"
import "./styles.css"
import assets from "./assets"
import EventProvider from "./contexts/DayContext"
import DebugControllers from "./components/DebugController"
import RouterWrapper from "./components/RouterWrapper"

const popups = [
	/* {
		ID: "53553345-f781-4bbd-84f7-1259183467d5",
		trigger: "exploration-threat-crypto",
	} */
]

const handleNewRoute = ({ previous, url }) => {
	if (
		window.dataLayer[0]["Registrant Type"] === "Non-Member"
		&& !["/atrium", "/breakout-four", "/auditorium", "/breakouts", "/sponsor-theatre"].includes(url)
		&& !url.match(/exhibition-hall/)
	) {
		route(previous || "/atrium")
	}
	// JS time works in milliseconds so for a 2h timeout we need:
	// 1000 ms per second * 3600 s per hour * 2 hours
	window.lastPageLoad = new Date()
	trackEvent({
		eventID: assets.eventId,
		from: previous?.replace(/^\//g, "").replace(/^$/g, "atrium") || null,
		to: url.replace(/^\//g, "").replace(/^$/g, "atrium"),
		type: "Venue Navigation",
		userID: window.dataLayer[0]["Registrant ID"],
	})
}

render(<>
		<script src="https://player.vimeo.com/api/player.js"></script>
		<script src="https://apps.elfsight.com/p/platform.js" />
		<EventProvider day={null} debug={assets.debug} backup={assets.auditorium.useBkp}>
			<>
				<DebugControllers days={3}/>
				<Navbar />
				{/* {window.dataLayer[0]["I would like to opt in to the Leaderboard competition"] === "Yes" ? <LeaderboardPopup /> : null} */}
				<LeaderboardPopup />
				<HowToEarnPoints />
				<RouterWrapper handleNewRoute={handleNewRoute}/>
			</>
		</EventProvider>
	</>,
	document.getElementById("content"),
)